module.exports = __webpack_public_path__ + "img/logo.f7b69a93.png";